import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { IFisma } from "../models/type";
import { getFismaAttrs } from "../apis/fisma";

const useFismaAttrQuery = (): UseQueryResult<IFisma> => {
  const result = useQuery(["fisma-page"], getFismaAttrs, {
    staleTime: Infinity,
  });

  return result;
};

export default useFismaAttrQuery;
